// extracted by mini-css-extract-plugin
export var close = "my-nfts-module--close--evng7";
export var grid = "my-nfts-module--grid--Kzk28";
export var highlight = "my-nfts-module--highlight--Szr11";
export var myNfts = "my-nfts-module--myNfts--AoBj5";
export var nft = "my-nfts-module--nft--VZw8Y";